<template>
  <!-- 供应商管理 -->
  <div class="supplier-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="名称/联系电话" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="openDialog()">新增供应商</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <separator-page :show-border="true">
          <template #category>
            <tree-dictionary :filter="true" v-model:dictionary-list="supplierCategoryTree" dictionary-type="SUPPLIER_CATEGORY" @clickCategory="clickCategory" dialog-label="供应商分类管理">
            </tree-dictionary>
          </template>
          <yq-table :data="dataList" height="100%" stripe border page-name="supplierList">
            <yq-table-column label="供应商名称" prop="merchantRemarkName" min-width="200rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="联系电话" prop="merchantRemarkPhone" width="150rem"/>
            <yq-table-column label="地区" prop="merchantRegion">
              <template v-slot="{row}">
                <administrative v-model="row.merchantRegion" :disabled="true"/>
              </template>
            </yq-table-column>
            <yq-table-column label="地址" prop="merchantAddress" min-width="200rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
              <template v-slot="{row}">
                <table-button-group label="更多操作">
                  <table-button type="write" @click="openDialog(row)">编辑</table-button>
                  <table-button type="delete" el-type="danger" message="是否确认删除该供应商" @click="toDelete(row)">删除</table-button>
                </table-button-group>
              </template>
            </yq-table-column>
          </yq-table>
        </separator-page>

      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑供应商' : '新增供应商'" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" ref="dialogData" :columns="2" label-width="2.4rem" icon-width="0">
        <form-item label="供应商名称" :required="true" error-message="请输入供应商名称" name="merchantRemarkName">
          <el-input v-model="dialogData.merchantRemarkName" placeholder="请输入供应商名称"/>
        </form-item>
        <form-item label="联系电话">
          <el-input v-model="dialogData.merchantRemarkPhone" placeholder="请输入联系电话"/>
        </form-item>
        <form-item label="联系人">
          <el-input v-model="dialogData.emergencyContact" placeholder="请输入联系人"/>
        </form-item>
        <form-item label="联系人性别">
          <el-select v-model="dialogData.merchantGender" placeholder="请选择性别">
            <el-option :value="1" label="男"/>
            <el-option :value="2" label="女"/>
          </el-select>
        </form-item>
        <form-item label="地区">
          <administrative v-model="dialogData.merchantRegion"/>
        </form-item>
        <form-item label="负责人">
          <!-- 多选且可拖拽排序：排在第一位的是主要负责人，其余作为业务人员 -->
          <employee-select-sort v-model="dialogData.ownerEmployeeIds"/>
        </form-item>
        <form-item label="联系地址" :show-block="true">
          <el-input v-model="dialogData.merchantAddress" placeholder="请输入联系地址"/>
        </form-item>
        <form-item label="供应商分类">
          <el-tree-select v-model="dialogData.partnerCategory" :data="supplierCategoryTree" default-expand-all check-strictly :render-after-expand="true" placeholder="请选择分类" :props="{children: 'children', label: 'dictName'}" node-key="dictCode"/>
        </form-item>
        <form-item label="备注信息" :show-block="true">
          <el-input v-model="dialogData.merchantRemark" :rows="5" type="textarea" placeholder="请输入备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import supplierApi from "@/api/normal/common/supplierApi";
import EmployeeSelectSort from "@/components/h5/data/EmployeeSelectSort.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SupplierList",
  components: {
    TreeDictionary,
    Administrative, EmployeeSelectSort,
    FormItems, FormItem, DialogTable,
    YqTableColumn, TableButtonGroup, TableButton,
    SearchCondition, FormPage, ListTable, ListPage, SeparatorPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1, pageSize: 10},
      dataList: [],
      showDialog: false,
      dialogData: {
        emergencyContact: "",
        // 负责人id串，逗号分隔，第一位是主要负责人
        ownerEmployeeIds: "",
      },
      supplierCategoryTree: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
  },
  methods: {
    queryList() {
      supplierApi.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    openDialog(row) {
      if (row) {
        this.dialogData = JSON.parse(JSON.stringify(row));
        // 列表接口已一并返回负责人，这里只保证非空，避免组件拿到 undefined
        this.dialogData.ownerEmployeeIds = this.dialogData.ownerEmployeeIds || "";
      } else {
        this.dialogData = {
          contactType: 0, // 这是一个企业
          // 新建时默认把当前登录人设为主要负责人：普通角色只看得到与自己相关的数据，
          // 留空会导致刚建完的供应商在列表里查不到。异步获取用户信息会覆盖用户已改的表单，所以同步取。
          ownerEmployeeIds: Util.getEmployeeId(),
        };
      }
      this.showDialog = true;
    },
    saveData() {
      if (!this.$refs.dialogData.validCheck()) {
        return;
      }
      supplierApi.saveSupplier(this.dialogData).then(() => {
        this.showDialog = false;
        this.queryList();
      })
    },
    toDelete(row) {
      supplierApi.delete(row.id).then(() => {
        this.queryList();
      })
    },
    clickCategory(data) {
      this.searchInfo.category = data.dictCode;
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.supplier-list {
  height: 100%;
}
</style>
